import Loader from "components/shared/loader";
import React, { lazy, Suspense } from "react";

const Gallery = lazy(() => import("react-image-gallery"));

export default function ImageGallery(props) {
    return (
        <Suspense fallback={<Loader />}>
            <Gallery lazyLoad showPlayButton={false} {...props} />
        </Suspense>
    );
}
